import { emp } from 'constants/urls';
import CryptoJS from 'crypto-js';
import { toB64 } from 'utils/base64';
import { getNowMsTimeStampUTC } from 'utils/date';
import { timeout } from 'utils/funciones';
import { generateUniqueId } from 'utils/string';

const HEADER_ALGORITHM = 'sha256';
const HEADER_TYPE = 'JWT';
const HEADER_KEY = 'X-API-KEY';

export class ApiKeyFetch {
  /** @typedef {ApiKeyFetch} */
  static INSTANCE = null;

  obtainToken = () => {
    const header = this.generateHeader();
    const payload = this.generatePayload();
    const signature = this.generateSignature(header, payload);

    return `${header}.${toB64(payload)}.${signature}`;
  };

  generateHeader = () => {
    const header = {
      alg: HEADER_ALGORITHM,
      typ: HEADER_TYPE,
    };

    return toB64(header);
  };

  generatePayload = () => {
    const jti = generateUniqueId('auth-');
    const iat = getNowMsTimeStampUTC();

    return {
      client_id: process.env.REACT_APP_CLIENT_ID,
      iat,
      jti,
    };
  };

  generateSignature = (header, payload) => {
    const secretKey = process.env.REACT_APP_CLIENT_SECRET_KEY;
    payload['secret_key'] = secretKey;
    const data = `${header}.${toB64(payload)}`;

    const signature = CryptoJS.HmacSHA256(data, secretKey);

    return signature.toString(CryptoJS.enc.Base64);
  };

  /**
   *
   * @returns {ApiKeyFetch}
   */
  static instance = () => {
    if (ApiKeyFetch.INSTANCE === null) {
      ApiKeyFetch.INSTANCE = new ApiKeyFetch();
    }
    return ApiKeyFetch.INSTANCE;
  };

  /**
   * Realiza una petición POST a la API con la clave API en los headers.
   * @param {string} url - La URL de la API a la que se realiza la petición.
   * @param {object} body - El cuerpo de la petición.
   * @returns {Promise} La respuesta de la API en forma de promesa.
   * @throws {Error} Si la petición a la API falla.
   */
  post = async (url, body = {}) => {
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          empresa: emp,
          plataforma: 'WEB',
          Data: body,
        }),
        headers: {
          [HEADER_KEY]: this.obtainToken(),
        },
      }).then((res) => res.json());
      return response;
    } catch (error) {
      console.log('ERROR:', error);
      return {
        ...error,
        errorDescripcion:
          error?.errorDescripcion?.errorDescripcion ||
          error?.errorDescripcion ||
          'Error al Consultar',
        transaccion: false,
      };
    }
  };

  /**
 * Función para realizar una solicitud POST a una URL específica con datos en formato JSON.
 * @param {string} url - La URL a la que se enviará la solicitud POST.
 * @param {FormData} formData - Los datos en formato JSON que se enviarán en el cuerpo de la solicitud.
 * @returns {Promise} - La respuesta de la API en forma de promesa.
 */
  postFile = async (url, formData) => {        
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
          [HEADER_KEY]: this.obtainToken(),
        },
      }).then((res) => res.json());
      return response;
    
  };

/**
   *
   * @param {any} url
   * @param {any} body
   * @param {any} defaultData
   * @returns {any}
   */
  postDummy = async (url, body = {}, defaultData = {}) => {
    console.log('FECHING... ', url, 'WITH BODY... ', body);
    await timeout(2000);
    return defaultData;
  };
}

// const API = ApiKeyFetch.instance();

// await API.post(
//   '',
//   {},
//   {
//     transaccion: true,
//     data: {},
//   }
// );
